import { render, staticRenderFns } from "./ProfileChangeRequestList.vue?vue&type=template&id=46fb862e&scoped=true&"
import script from "./ProfileChangeRequestList.vue?vue&type=script&lang=js&"
export * from "./ProfileChangeRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileChangeRequestList.vue?vue&type=style&index=0&id=46fb862e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb862e",
  null
  
)

export default component.exports